import { render } from "./RegexForm.vue?vue&type=template&id=6b212520&ts=true"
import script from "./RegexForm.vue?vue&type=script&lang=ts"
export * from "./RegexForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__